import ActionButton from './../../components/ActionButton'; 
import { Info } from 'lucide-react';

const MAX_ALLOWED_LENGTH = 255;

const QuestionStep = ({ question, setQuestion, onNext }) => {
  const isInputEmpty = !question.trim();
  const isTooLong = question.length > MAX_ALLOWED_LENGTH;
  const isInvalid = isInputEmpty || isTooLong;

  // Dynamically set classes for validation feedback
  const textareaClasses = `
    w-full px-4 py-3 border rounded-lg focus:outline-none focus:ring-2 transition-shadow duration-200
    ${isTooLong ? 'border-red-500 focus:ring-red-500' : 'border-gray-300 focus:ring-blue-500'}
  `;

  return(
  <>
    <div className="w-full text-center mb-6">
        <h2 className="text-2xl font-bold text-gray-800">Zadejte výzkumnou otázku</h2>
        <p className="">Krok 1</p>
    </div>

    <div className="w-full mb-4">
      <div className="flex items-start gap-2 rounded-lg mb-4 text-gray-500">
        <Info className="w-5 h-5 flex-shrink-0 text-500 mt-0.5" />
        <p>Napište celou otázku přesně tak, jak byla zadána respondentům.</p>
      </div>
      <textarea
        id="question"
        rows="4"
        className={textareaClasses}
        value={question}
        onChange={(e) => setQuestion(e.target.value)}
        placeholder="Např.: „Které značky automobilů si vybavíte?“ nebo „Co se Vám vybaví, když se řekne XY?“"
      />
      <div className="flex justify-between items-center mt-2 text-sm">
          {isTooLong ? (
            <p className="text-red-600 font-medium">
              Text je příliš dlouhý (maximum je {MAX_ALLOWED_LENGTH} znaků).
            </p>
          ) : (
            // Placeholder to keep counter aligned to the right
            <span></span> 
          )}
          <p className={`ml-auto ${isTooLong ? 'text-red-600 font-semibold' : 'text-gray-500'}`}>
            {question.length} / {MAX_ALLOWED_LENGTH}
          </p>
        </div>
    </div>
    <ActionButton onClick={onNext} disabled={isInvalid}>
      Pokračovat
    </ActionButton>
  </>
);
}
export default QuestionStep;